import styled from 'styled-components';
import tw from 'twin.macro';

export const FormFieldSet = styled.fieldset`
  ${tw`flex flex-col items-center justify-start w-full h-full`};
`;

export const MultiStepFormFooterWrapper = styled.div`
  ${tw`flex flex-grow-default justify-end flex-col w-full items-center mt-24px`}
`;
